// extracted by mini-css-extract-plugin
export default {"usersList":"styles_usersList__RBimV","text":"styles_text__Sfrpk","checkbox":"styles_checkbox__FYM26","avatarItem":"styles_avatarItem__R7Tii","listItem":"styles_listItem__22Q9r"};